import { useState } from "react";
import { CiSquareChevDown } from "react-icons/ci";
import TestRange from "../testResultTypes/TestRange";
import { factor_convertor, normalizeValue } from "../../../utils/Functions";
import TestMinMax from "../testResultTypes/TestMinMax";
import TestTrueFalse from "../testResultTypes/TestTrueFalse";

const DataComponent = ({ data, gender, defaultChecked }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const factorResult = data.result_value ? data.text_value : data.text_value;

  const factorResultType = Number(factorResult);

  const selectedRange =
    data.range.length > 1
      ? data.range.find((item: any) => item.sex === gender.toLowerCase())
      : data.range[0];

  const normalizedValue = normalizeValue(
    factorResult,
    selectedRange?.min_value,
    selectedRange?.max_value
  );

  const details = [
    {
      title: `دلایل متداول کمبود ${data.name}`,
      value: data.reasons_and_problems.find(
        (item: any) => item.component_state === "L" && item.type === "R"
      )?.description,
      category: ["l"],
    },
    {
      title: `دلایل متداول افزایش ${data.name}`,
      value: data.reasons_and_problems.find(
        (item: any) => item.component_state === "H" && item.type === "R"
      )?.description,
      category: ["h"],
    },
    {
      title: `مشکلات ناشی از کمبود ${data.name}`,
      value: data.reasons_and_problems.find(
        (item: any) => item.component_state === "L" && item.type === "P"
      )?.description,
      category: ["l"],
    },
    {
      title: `مشکلات ناشی از افزایش ${data.name}`,
      value: data.reasons_and_problems.find(
        (item: any) => item.component_state === "H" && item.type === "P"
      )?.description,
      category: ["h"],
    },
    {
      title: `مقدار نرمال ${data.name}`,
      value: data.normal_situation,
      category: ["ln", "n", "hn", "normal"],
    },
    {
      title: `مقدار غیرمعمولی ${data.name}`,
      value: data.normal_situation,
      category: ["abnormal"],
    },
  ];

  return (
    <div className="collapse bg-white border-2 rounded-lg mb-3">
      <input
        type="checkbox"
        className="h-full"
        onChange={(e) => setIsOpen(e.target.checked)}
      />
      <div
        className={`relative collapse-title text-xl font-medium lg:px-8 lg:pt-8 px-6 ${
          isOpen ? "pb-20" : "pb-28"
        }`}
      >
        <div className="flex items-start justify-between relative">
          <div className="flex flex-col lg:flex-row items-start lg:items-center">
            <h2 className="font-rokh text-base font-[700] rounded-xl bg-pr_primary text-white flex items-center pt-[6px] px-3">
              {data.name}
            </h2>
            <h3 className="text-[17px] font-rokh font-[900] mt-3 lg:mt-1 lg:mr-3 hidden lg:block">
              {data.fa_name}
            </h3>
          </div>
          <div className="flex items-center">
            <h4
              className="font-rokh font-[900] ml-2 mt-1"
              style={{
                color: factor_convertor(data.status).color,
              }}
            >
              {factor_convertor(data.status).text}
            </h4>
          </div>
        </div>
        <h3 className="text-[16px] font-rokh font-[900] mt-3 lg:mt-1 lg:mr-3 block lg:hidden">
          {data.fa_name}
        </h3>

        <p className="mt-5 text-sm text-right">{data.description}</p>

        {
          //@ts-ignore
          String(factorResult)?.toLowerCase() === "true" ||
          //@ts-ignore
          String(factorResult)?.toLowerCase() == "false" ? (
            <TestTrueFalse
              //@ts-ignore
              value={factorResult}
            />
          ) : Number.isNaN(factorResultType) ? (
            <div className="bg-gray-100 inline-block px-6 py-1 rounded-lg mt-3">
              <p className="text-sm inline">{factorResult}</p>
            </div>
          ) : normalizedValue?.toString().includes("_") ? (
            <TestMinMax
              unit={data.unit}
              min={selectedRange?.min_value}
              max={selectedRange?.max_value}
              value={Number(factorResult)}
              status={data.status}
            />
          ) : (
            <TestRange
              unit={data.unit}
              value={Number(factorResult)}
              range={selectedRange}
              status={data.status}
            />
          )
        }

        {!isOpen && (
          <div className="absolute bottom-0 left-0 w-full flex items-center justify-center py-2 lg:pl-8 bg-gray-100">
            <h6 className="flex items-center">
              <span className="font-rokh font-[900] text-[15px] mt-[6px] ml-2">
                اطلاعات بیشتر
              </span>
              <CiSquareChevDown size={23} />
            </h6>
          </div>
        )}
      </div>
      <div className="collapse-content">
        <div className="flex flex-col lg:flex-row justify-between align-start gap-4 mb-4">
          {details.length > 0 &&
            details
              .filter((item: any) =>
                item.category.includes(data.status?.toLowerCase())
              )
              ?.map((detail: any, idx: number) => (
                <div className="flex-1" key={idx}>
                  <h5 className="font-rokh font-[900] mt-2 text-md border-b-[1px] pb-1 mb-5">
                    {detail.title}
                  </h5>
                  <ul className="mt-2 list-disc list-inside">
                    {detail.value?.map((val: any, idx: number) => (
                      <li key={idx} className="text-sm">
                        {val}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default DataComponent;
